import { render, staticRenderFns } from "./ParsedLinks.vue?vue&type=template&id=1eedb5a2&scoped=true&"
import script from "./ParsedLinks.vue?vue&type=script&lang=js&"
export * from "./ParsedLinks.vue?vue&type=script&lang=js&"
import style0 from "./ParsedLinks.vue?vue&type=style&index=0&id=1eedb5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eedb5a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eedb5a2')) {
      api.createRecord('1eedb5a2', component.options)
    } else {
      api.reload('1eedb5a2', component.options)
    }
    module.hot.accept("./ParsedLinks.vue?vue&type=template&id=1eedb5a2&scoped=true&", function () {
      api.rerender('1eedb5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/ParsedLinks.vue"
export default component.exports